export const API_URL = process.env.REACT_APP_API_URL;
export const API_CARTE_URL = process.env.REACT_APP_API_CARTE_URL //for GeoJSon